import React, { useEffect, useState } from 'react';
import { Card, Switch, Space, Collapse, Spin, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useParams, Link, useHistory } from 'react-router-dom';
import "swagger-ui-react/swagger-ui.css";
import { getApiDocDetail } from '../../apis/apiDocs';
import { getApisList } from '../../apis/apis';
import HomePageLayout from '../Layout/HomePageLayout';
import MethodTag from '../Method';
import { openErrorNotification } from '../../utils/notification'

const { Panel } = Collapse;

const ApiDocDetail = () => {

  const [apiDocDetail, setDetail] = useState({});
  const [apiList, setApiList] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const history = useHistory();

  if (!id) {
    history.push('/not-found')
  }

  const fetchApis = async (id) => {
    try {
      const docListRes = await getApisList(id);
      setApiList(docListRes)
    } catch (error) {
      openErrorNotification('Our system can not fetch data! Please try again')
      console.log(error);
    }
  }

  useEffect(() => {
    const fetchApiDocDetail = async () => {
      try {
        if (id ?? false) {
          setLoading(true);
          const servieDetailRes = await getApiDocDetail(id);
          await fetchApis(id);
          setDetail(servieDetailRes);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        openErrorNotification('Our system can not fetch data! Please try again')
        console.log(error);
      }
    }
    fetchApiDocDetail();
  }, [id]);


  return (
    <HomePageLayout>
      <Spin spinning={loading}>
        <div>
          <Button type="primary" size="large">
            <Link to={`/service-entries/${apiDocDetail?.serviceEntryId}`}><ArrowLeftOutlined /> Back</Link>
          </Button>
        </div>
        <br />
        <div>
          {
            apiDocDetail?.name &&
            (<div>
              <Card title={apiDocDetail.name}>
                <div>
                  <Space>
                    <p>Title:</p>
                    <p>
                      {apiDocDetail.title}
                    </p>
                  </Space>
                </div>
                <div>
                  <Space>
                    <p>Description:</p>
                    <p>
                      {apiDocDetail.description}
                    </p>
                  </Space>
                </div>
              </Card>
            </div>)
          }
        </div>

        <Card title="All Apis">
          <Collapse>
            {
              apiList && apiList.map((doc, index) => {
                return (
                  <Panel
                    header={
                      <Space>
                        <b>{doc.externalPath || doc.path}</b>
                        <MethodTag method={doc.method} />
                      </Space>
                    }
                    key={index}>
                    <div>
                      <Space>
                        <p>Method:</p>
                        <p>
                          <MethodTag method={doc.method} />
                        </p>
                      </Space>
                    </div>
                    <div>
                      <Space>
                        <Button type="primary">
                          <Link to={`/apis/${doc.id}`}>Detail</Link>
                        </Button>
                      </Space>
                    </div>
                  </Panel>
                )
              })
            }
          </Collapse>
        </Card>
      </Spin>
    </HomePageLayout>
  )
}

export default ApiDocDetail;